import { useEffect, useState } from 'react'

/**
 * Get the token if it comes from sso
 * 
 * @returns sso
 */
const useSSO = () => {
  const [sso, setSso] = useState('No tiene')
  useEffect(() => {
    fetch(document.location).then(async data => {
      setSso(data?.headers.get('Authorization') ? data?.headers.get('Authorization') : 'No tiene')
    })

  }, [])

  return [sso]
}

export default useSSO
